import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IAgronomyAgreementServicesContextValue } from './types';

export default createContext<IAgronomyAgreementServicesContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
